import { createSlice } from '@reduxjs/toolkit';
import {
  fetchadminCLientOrderDisplay,
  fetchAdminClientTextOrderDisplay,
  fetchadminCLientOrderLineDisplay,
} from './features';

export const adminCLientOrderDisplay = createSlice({
  name: 'adminCLientOrderDisplay',
  initialState: {
    order: null,
    status: '',
    textList: [],
    orderId: null,
    orderLineList: [],
    remainingTextAmount: 0,
    affectedTextAmount: 0,
    isLoading: true,
    isError: true,
    isTextLoading: false,
    isTextError: false,
    isOrderLineLoading: true,
    isOrderLineError: true,
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setOrderLineList: (state, { payload }) => {
      let array = [
        ...payload.map((orderLine) => ({
          ...orderLine,
          deadline: orderLine.deadline ? orderLine.deadline.slice(0, 10) : null,
        })),
      ];
      state.orderLineList = [...array];
    },
    updateOrderDetails: (state, { payload }) => {
      state.order = payload;
      state.isLoading = false;
      state.isError = false;
    },

    updateOrderLine: (state, { payload }) => {
      const array = [...state.orderLineList];
      const index = array.findIndex((orderLine) => {
        const lineId =
          orderLine.writerProjectId ??
          orderLine.writerCommandId ??
          orderLine.id;
        return lineId === payload.id;
      });
      if (index > -1) {
        array[index] = {
          ...array[index],
          [payload.option]: payload.value,
        };
        state.orderLineList = array;
      }
    },
    removeOrderLine: (state, action) => {
      state.orderLineList = state.orderLineList.filter((item) => {
        const lineId =
          item.writerProjectId ?? item.writerCommandId ?? item.id;
        return lineId !== action.payload;
      });
    },
    updateRemainingTextAmount: (state, { payload }) => {
      state.remainingTextAmount = payload;
    },
    updateAffectedTextAmount: (state, { payload }) => {
      state.affectedTextAmount = payload.reduce(
        (a, b) => parseInt(a) + (parseInt(b['textAmount']) || 0),
        0
      );
    },
    updateTextOfTextList: (state, { payload }) => {
      let array = [...state.textList];
      let index = array.findIndex((text) => text.id === payload.id);
      if (index > -1) {
        array[index][payload.key] = payload.value;
        state.textList = [...array];
      }
    },
    removeTextOfTextList: (state, action) => {
      state.textList = state.textList.filter(
        (item) => item.id !== action.payload
      );
    },
    deleteAllTexts: (state) => {
      state.textList = [];
    },
    deliverTextsOfTextList: (state, { payload }) => {
      let array = [...state.textList];

      payload.selectedTextsForDelivery.forEach((id) => {
        let index = array.findIndex((text) => text.id === id);
        if (index > -1) {
          array[index][payload.key] = payload.value;
        }
      });

      state.textList = array;
    },
    reDraftTextsOfTextList: (state, { payload }) => {
      let array = [...state.textList];

      payload.selectedTextsToReDraft.forEach((id) => {
        let index = array.findIndex((text) => text.id === id);
        if (index > -1) {
          array[index][payload.key] = payload.value;
        }
      });

      state.textList = array;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchadminCLientOrderDisplay.fulfilled, (state, { payload }) => {
        state.order = payload;
        state.isLoading = false;
        state.isError = false;
      })
      .addCase(fetchadminCLientOrderDisplay.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchadminCLientOrderDisplay.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(
        fetchAdminClientTextOrderDisplay.fulfilled,
        (state, { payload }) => {
          state.textList = payload.map((text, index) => ({
            index,
            ...text,
          }));

          state.isTextLoading = false;
          state.isTextError = false;
        }
      )
      .addCase(fetchAdminClientTextOrderDisplay.pending, (state) => {
        state.isTextLoading = true;
        state.isTextError = false;
      })
      .addCase(fetchAdminClientTextOrderDisplay.rejected, (state) => {
        state.isTextLoading = false;
        state.isTextError = true;
      })
      .addCase(
        fetchadminCLientOrderLineDisplay.fulfilled,
        (state, { payload }) => {
          state.orderId = payload.commandId;
          state.remainingTextAmount = payload.commandTextAmount;

          state.orderLineList = payload['projectLineDtos'].map((orderLine) => ({
            ...orderLine,
            deadline: orderLine.deadline ? orderLine.deadline.slice(0, 10) : null,
          }));
          state.affectedTextAmount = payload['projectLineDtos'].reduce(
            (a, b) => parseInt(a) + (parseInt(b['textAmount']) || 0),
            0
          );
          state.isOrderLineLoading = false;
          state.isOrderLineError = false;
        }
      )
      .addCase(fetchadminCLientOrderLineDisplay.pending, (state) => {
        state.isOrderLineLoading = true;
        state.isOrderLineError = false;
      })
      .addCase(fetchadminCLientOrderLineDisplay.rejected, (state) => {
        state.isOrderLineLoading = false;
        state.isOrderLineError = true;
      });
  },
});

export default adminCLientOrderDisplay.reducer;

export const adminCLientOrderDisplaySelector = (state) =>
  state.adminCLientOrderDisplay;

export const {
  setStatus,
  setOrderLineList,
  removeOrderLine,
  updateOrderDetails,
  updateOrderLine,
  updateRemainingTextAmount,
  updateAffectedTextAmount,
  updateTextOfTextList,
  removeTextOfTextList,
  deleteAllTexts,
  deliverTextsOfTextList,
  reDraftTextsOfTextList,
} = adminCLientOrderDisplay.actions;
